import { render, staticRenderFns } from "./perfect-scrollbar.vue?vue&type=template&id=69c05052"
import script from "./perfect-scrollbar.vue?vue&type=script&lang=js"
export * from "./perfect-scrollbar.vue?vue&type=script&lang=js"
import style0 from "./perfect-scrollbar.vue?vue&type=style&index=0&id=69c05052&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c05052')) {
      api.createRecord('69c05052', component.options)
    } else {
      api.reload('69c05052', component.options)
    }
    module.hot.accept("./perfect-scrollbar.vue?vue&type=template&id=69c05052", function () {
      api.rerender('69c05052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/perfect-scrollbar.vue"
export default component.exports